import RequestsActions from 'client/core/RequestsActions'
import { action } from 'client/core/actions'

export const ClientsRequest = new RequestsActions('CLIENTS')
export const HiveRequest = new RequestsActions('HIVE')

/*Set current*/
export const SET_CURRENT_CLIENT = 'SET_CURRENT_CLIENT'
export const setCurrentClient = (_id) => action(SET_CURRENT_CLIENT, { _id })

export const CLIENT_SEARCH_CHANGE = 'CLIENT_SEARCH_CHANGE'
export const clientSearchChange = (payload) => action(CLIENT_SEARCH_CHANGE, { payload })


// WEBPACK FOOTER //
// ./src/client/features/client/actions.js